(() => {
  const dialog = document.getElementById('VfCartConfirmation');
  const selector = document.querySelector('[data-vf-cut-selector]');
  if (!dialog || !selector || typeof dialog.showModal !== 'function') return;
  const strings = JSON.parse(dialog.querySelector('[data-vf-confirm-strings]').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const checkout = dialog.querySelector('[data-vf-confirm-checkout]');
  const status = dialog.querySelector('[data-vf-confirm-status]');
  const title = document.getElementById('VfCartConfirmationTitle');
  const summary = dialog.querySelector('[data-vf-confirm-summary]');
  let returnFocus;
  let sequence = 0;
  let confirmation;
  let requestNumber = 0;

  const readJSON = async (input, accept = 'application/json', format = 'json') => {
    const url = new URL(input, window.location.origin);
    url.searchParams.set('_vf_cart_refresh', `${Date.now()}-${++requestNumber}`);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url, {
        credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: accept }, signal: controller.signal,
      });
      if (!response.ok) throw new Error('Cart unavailable');
      return await response[format]();
    } finally {
      clearTimeout(timeout);
    }
  };

  const showStatus = (message) => {
    status.textContent = message || '';
    status.hidden = !message;
  };
  const weightsReady = (cart) => Array.isArray(cart?.items) && cart.items.length > 0 && cart.items.every((item) => {
    if (!item.properties?.['Requested cut length']) return true;
    const expected = Number(item.properties['_Estimated material weight grams']);
    const native = Number(item.grams);
    const legacy = !item.properties['_Expected cut price cents'] && !item.properties['_Cut price currency'];
    const expectedPrice = Number(legacy
      ? cart.vf_legacy_prices?.find((entry) => entry.key === item.key)?.price
      : item.properties['_Expected cut price cents']);
    const priceReady = Number.isSafeInteger(expectedPrice) && expectedPrice > 0
      && Number(item.original_price) === expectedPrice
      && (legacy || item.properties['_Cut price currency'] === cart.currency);
    return Number.isFinite(expected) && Number.isFinite(native) && expected > 0 && native > 0 && Math.abs(expected - native) <= 5 && priceReady;
  });
  const readCart = async () => {
    let cart = await readJSON(root + 'cart.js');
    if (cart.items?.some((item) => item.properties?.['Requested cut length'] && !item.properties['_Expected cut price cents'] && !item.properties['_Cut price currency'])) {
      const verified = await readJSON(root + 'cart?view=vf-cut-verification', 'text/html');
      if (!Array.isArray(verified.cart?.items) || !Array.isArray(verified.legacyPrices)) throw new Error('Cart verification unavailable');
      cart = verified.cart;
      cart.vf_legacy_prices = verified.legacyPrices;
    }
    if (!Array.isArray(cart.items)) throw new Error('Cart unavailable');
    return cart;
  };
  const matches = (item, added) => String(item.variant_id) === String(added.variantId)
    && item.properties?.['_Billet SKU'] === added.sku
    && item.properties?.['Requested cut length'] === added.length;

  const updateSummary = (cart) => {
    const subtotal = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cart.currency || 'USD' }).format(cart.total_price / 100);
    summary.textContent = (cart.item_count === 1 ? strings.one_item : strings.many_items).replace('[count]', String(cart.item_count)).replace('[subtotal]', subtotal);
  };

  const updateCartCount = (cart) => {
    const count = Number(cart.item_count);
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon || !Number.isSafeInteger(count) || count < 0) return;
    let bubble = icon.querySelector('.cart-count-bubble');
    if (count === 0) bubble?.remove();
    else {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        icon.append(bubble);
      }
      const visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      visible.textContent = count < 100 ? String(count) : '';
      const accessible = document.createElement('span');
      accessible.className = 'visually-hidden';
      const label = icon.querySelector(':scope > .visually-hidden')?.textContent.trim() || '';
      accessible.textContent = `${label}: ${count}`;
      bubble.replaceChildren(visible, accessible);
    }
    icon.querySelector('svg')?.classList.toggle('filled', count > 0);
    icon.querySelector('svg')?.classList.toggle('empty', count === 0);
  };

  const refreshCartUI = async (cart, current) => {
    const parser = new DOMParser();
    const drawer = document.querySelector('cart-drawer');
    const target = drawer?.querySelector('#CartDrawer .drawer__inner');
    if (!target) return;
    const prepare = (html) => {
      const source = parser.parseFromString(html || '', 'text/html').querySelector('#CartDrawer .drawer__inner');
      if (!source) throw new Error('Cart display unavailable');
      const count = [...source.querySelectorAll('input[name="updates[]"]')]
        .reduce((sum, input) => sum + Number(input.value), 0);
      if (count !== cart.item_count) throw new Error('Cart display still updating');
      return source;
    };
    let source;
    try {
      const url = new URL(root + 'cart', window.location.origin);
      url.searchParams.set('sections', 'cart-drawer');
      const sections = await readJSON(url, 'text/html');
      source = prepare(sections['cart-drawer']);
    } catch {
      source = prepare(await readJSON(root + 'cart', 'text/html', 'text'));
    }
    if (current !== sequence) return;
    const focus = document.activeElement;
    const focusId = focus?.id;
    const losesFocus = target.contains(focus);
    const notes = [...target.querySelectorAll('textarea[name="note"]')].map((note) => ({ id: note.id, value: note.value }));
    target.innerHTML = source.innerHTML;
    notes.forEach((note) => { const element = document.getElementById(note.id); if (element) element.value = note.value; });
    [drawer, target, ...target.querySelectorAll('cart-drawer-items')].forEach((element) => element.classList.toggle('is-empty', cart.item_count === 0));
    updateCartCount(cart);
    if (drawer.classList.contains('active') && !dialog.open && typeof trapFocus === 'function') {
      const nextFocus = (focusId && document.getElementById(focusId)) || target.querySelector('.drawer__close') || target;
      trapFocus(target, losesFocus ? nextFocus : focus);
    }
  };

  const restoreForm = (options) => {
    selector.finishPurchase?.();
    document.querySelectorAll('.input-file').forEach((input) => { if (input.prevName) input.name = input.prevName; });
    if (document.querySelector('[name="id_prev"]')) {
      document.querySelectorAll('[name="id"]').forEach((input) => input.remove());
      document.querySelectorAll('[name="id_prev"]').forEach((input) => { input.name = 'id'; });
    }
    document.querySelectorAll('#dpo-cart-properties, #dpo_tmp_form').forEach((element) => element.remove());
    selector.querySelectorAll('.submitting').forEach((element) => {
      element.classList.remove('submitting');
      element.querySelectorAll(':scope > *').forEach((child) => { child.style.opacity = ''; });
    });
    selector.querySelectorAll('[data-vf-submit]').forEach((button) => { button.removeAttribute('aria-disabled'); });
    if (options) options.prevAddToCartButton?.prop?.('disabled', false);
    selector.syncedVariantId = null;
    selector.update?.();
  };

  const confirm = async (added, data, options) => {
    const current = ++sequence;
    confirmation = added;
    restoreForm(options);
    returnFocus = selector.querySelector('[data-vf-submit]');
    checkout.disabled = true;
    title.textContent = data ? strings.title : strings.uncertain_title;
    dialog.querySelector('.vf-cart-confirmation__check').textContent = data ? '✓' : '!';
    dialog.querySelector('[data-vf-confirm-item]').textContent = strings.billet.replace('[sku]', added.sku) + '\n' + added.length;
    summary.textContent = '';
    showStatus(data ? strings.checking : strings.uncertain);
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('vf-confirm-open');
    dialog.querySelector('[data-vf-confirm-continue]').focus({ preventScroll: true });
    let cart;
    let uiSynced = false;
    let syncedReady = false;
    const deadline = Date.now() + 60000;
    for (let attempt = 0; attempt < 60 && Date.now() < deadline; attempt += 1) {
      try {
        cart = await readCart();
        if (current !== sequence) return;
        updateCartCount(cart);
        const ready = weightsReady(cart);
        if (cart.items.some((item) => matches(item, added)) && (!uiSynced || (ready && !syncedReady))) {
          await refreshCartUI(cart, current);
          if (current !== sequence) return;
          uiSynced = true;
          syncedReady = ready;
        }
        if (weightsReady(cart)) updateSummary(cart);
        if (cart.items.some((item) => matches(item, added)) && ready && uiSynced) break;
      } catch {}
      if (attempt < 59) await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    if (current !== sequence) return;
    const ready = data && cart?.items.some((item) => matches(item, added)) && weightsReady(cart);
    checkout.disabled = !ready;
    if (ready) updateSummary(cart);
    showStatus(ready ? '' : data ? strings.review : strings.uncertain);
  };

  document.addEventListener('vf:cart-ready', (event) => {
    const cart = event.detail;
    if (!confirmation || !weightsReady(cart) || !cart.items.some((item) => matches(item, confirmation))) return;
    updateCartCount(cart);
    updateSummary(cart);
    checkout.disabled = false;
    showStatus('');
  });

  const close = () => dialog.close();
  dialog.querySelector('[data-vf-confirm-close]').addEventListener('click', close);
  dialog.querySelector('[data-vf-confirm-continue]').addEventListener('click', close);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('vf-confirm-open');
    returnFocus?.focus({ preventScroll: true });
  });
  checkout.addEventListener('click', async () => {
    checkout.disabled = true;
    showStatus(strings.checking);
    try {
      const cart = await readCart();
      if (!cart.item_count) { showStatus(strings.empty); return; }
      if (!weightsReady(cart) || !cart.items.some((item) => matches(item, confirmation))) { showStatus(strings.review); return; }
      window.location.assign(root + 'checkout');
    } catch { showStatus(strings.review); }
    finally { checkout.disabled = false; }
  });

  const bind = (attempt = 0) => {
    if (!window.jQuery) {
      if (attempt < 100) window.setTimeout(() => bind(attempt + 1), 200);
      return;
    }
    window.jQuery(window).off('dpo_before_form_submit.vfConfirmation').on('dpo_before_form_submit.vfConfirmation', (_event, temp) => {
      const form = temp?.tagName === 'FORM' ? temp : temp?.[0];
      if (form?.tagName !== 'FORM' || !selector.contains(document.querySelector('[data-vf-form]')) || Number(window.dpoObserver?.directAddToCartSubmit) !== 2) return;
      selector.preparePurchaseForm?.(form);
      const formData = new FormData(form);
      const sku = formData.get('properties[_Billet SKU]');
      const length = formData.get('properties[Requested cut length]');
      if (!sku || !length) return;
      const options = window.dpoOptions;
      const previous = options.asyncAddToCartPostCheck;
      options.vfCutRestoreConfirmation = () => {
        options.asyncAddToCartPostCheck = previous;
        delete options.vfCutRestoreConfirmation;
      };
      options.asyncAddToCartPostCheck = function (variantId, data) {
        options.vfCutRestoreConfirmation();
        void confirm({ variantId, sku: String(sku), length: String(length) }, data, options);
      };
    });
  };
  bind();
})();




